var map = {
	"./news-2025-1.jpg": 40293,
	"./news-2025-10.jpg": 15113,
	"./news-2025-2.jpg": 83066,
	"./news-2025-3.jpg": 34999,
	"./news-2025-4.jpg": 74764,
	"./news-2025-5.jpg": 72553,
	"./news-2025-6.jpg": 97406,
	"./news-2025-7.jpg": 17563,
	"./news-2025-8.jpg": 75904,
	"./news-2025-9.jpg": 43997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96365;